const VideoPlyr = (target) => {
  const initPlyr = el => {
    // eslint-disable-next-line no-undef,no-unused-vars
    const player = new Plyr(el, {
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
    })
  };

  $('body').find(target)
    .each((_, el) => {
      initPlyr(el);
    });
}

export default VideoPlyr;



// WEBPACK FOOTER //
// ./scripts/components/VideoPlyr.js